<template>
  <div class="container auth-page">
    <div class="row">
      <div class="col-xs-12 col-md-8 ">

        <div class="panel panel-default">
          <div class="panel-heading">
            <strong>Disclaimer</strong>
          </div>
          <div class="panel-body">
            <p class="text-justify"><b>Please choose the plan you require to upgrade to and choose any features required or choose your current plan to add specific features</b></p>
          </div>
        </div>

        <div v-if="isIOSingleReview || isIOBulkReview || isAdditionalUser">
          <div v-if="isIOSingleReview">
            <div class="panel panel-default" v-if="ioSingleAdditionalProductAddons.length > 0">
              <div class="panel-heading"><strong>Select Additional</strong></div>
              <div class="panel-body">
                <div class="subscription-plans-container row">
                  <template v-for="ioSingleAdditionalProduct in ioSingleAdditionalProductAddons">
                    <div :class="{'col-md-3 disabled': ioSingleAdditionalProduct.is_blocked, 'col-md-3': !ioSingleAdditionalProduct.is_blocked}">
                      <div :class="`subscription-plan ${selectedProduct && ioSingleAdditionalProduct.id == selectedProduct.id ? 'active' : ''}`" :key="ioSingleAdditionalProduct.id" @click="selectProduct(ioSingleAdditionalProduct)">
                        <h3 class="subscription-title" style="text-align: center !important;">{{ioSingleAdditionalProduct.name}}</h3>
                        <span class="subscription-price">{{ioSingleAdditionalProduct.price_formatted}} + {{title_vat}}</span>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>

          <div v-if="isIOBulkReview">
            <div class="panel panel-default" v-if="ioBulkAdditionalProductAddons.length > 0">
              <div class="panel-heading"><strong>Select Additional</strong></div>
              <div class="panel-body">
                <div class="subscription-plans-container row">
                  <template v-for="ioBulkAdditionalProduct in ioBulkAdditionalProductAddons">
                    <div :class="{'col-md-3 disabled': ioBulkAdditionalProduct.is_blocked, 'col-md-3': !ioBulkAdditionalProduct.is_blocked}">
                      <div :class="`subscription-plan ${selectedProduct && ioBulkAdditionalProduct.id == selectedProduct.id ? 'active' : ''}`" :key="ioBulkAdditionalProduct.id" @click="selectProduct(ioBulkAdditionalProduct)">
                        <h3 class="subscription-title" style="text-align: center !important;">{{ioBulkAdditionalProduct.name}}</h3>
                        <span class="subscription-price">{{ioBulkAdditionalProduct.price_formatted}} + {{title_vat}}</span>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>

          <div v-if="isAdditionalUser">
            <div class="panel panel-default" v-if="additionalUserAdditionalProductAddons.length > 0">
              <div class="panel-heading"><strong>Select Additional</strong></div>
              <div class="panel-body">
                <div class="subscription-plans-container row">
                  <template v-for="additionalUserAdditionalProduct in additionalUserAdditionalProductAddons">
                    <div :class="{'col-md-3 disabled': additionalUserAdditionalProduct.is_blocked, 'col-md-3': !additionalUserAdditionalProduct.is_blocked}">
                      <div
                          :class="`subscription-plan ${addonProducts[additionalUserAdditionalProduct.id] ? 'active' : ''}`"
                          :key="additionalUserAdditionalProduct.id"
                          @click="selectAdditionalUserAddon(additionalUserAdditionalProduct)"
                      >
                        <h3 class="subscription-title" style="text-align: center !important;">
                          {{ additionalUserAdditionalProduct.name }}
                        </h3>
                        <span class="subscription-price">
                          {{ additionalUserAdditionalProduct.price_formatted }} + {{title_vat}}
                        </span>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div v-else>
          <div :class="{'panel panel-default disabled': isScanOnly, 'panel panel-default': !isScanOnly}">
            <div class="panel-heading"><strong>Select Subscription Plan</strong></div>
            <div class="panel-body">
              <div class="subscription-plans-container row">
                <template v-for="product in products" >
                  <div class="col-md-3">
                    <div
                        :class="[
                          'subscription-plan',
                          selectedProduct && product.id == selectedProduct.id ? 'active' : '',
                          product.is_current_plan ? 'current-plan' : ''
                        ]"
                        :key="product.id"
                        @click="selectProduct(product)"
                    >
                      <h3 class="subscription-title">{{product.name}}</h3>
                      <span v-if="product.slug !== 'enterprise_manual'" class="subscription-price">{{product.price_formatted}} + {{title_vat}}</span>
                      <p v-if="product.is_current_plan" class="text-center current-plan-text"><b>Your current plan</b></p>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>

          <div class="panel panel-default" v-if="additionalProductAddons.length > 0">
            <div class="panel-heading"><strong>Select Additional</strong></div>
            <div class="panel-body">
              <div class="subscription-plans-container row">
                <template v-for="additionalProduct in additionalProductAddons">
                  <div :class="{'col-md-3 disabled': additionalProduct.is_blocked, 'col-md-3': !additionalProduct.is_blocked}">
                    <div :class="`subscription-plan ${selectedProduct && additionalProduct.id == selectedProduct.id ? 'active' : ''}`" :key="additionalProduct.id" @click="selectProduct(additionalProduct)">
                      <h3 class="subscription-title" style="text-align: center !important;">{{additionalProduct.name}}</h3>
                      <span class="subscription-price">{{additionalProduct.price_formatted}} + {{title_vat}}</span>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>

        <div v-if="selectedProduct" class="panel panel-default">
          <div class="panel-heading"><strong>Register</strong></div>
          <div class="panel-body">
            <h2>{{ selectedProduct.name }}</h2>
            <template v-if="selectedProduct.addons && selectedProduct.addons.length > 0">
              <h3>Available Addons:</h3>
              <div class="addon-products">
                <div v-for="addon in selectedProduct.addons" :key="addon.id">
                  <addon-product
                      :product="getAddonProductForDisplay(addon)"
                      @toggleAddon="toggleAddon($event, addon)"
                  />


                  <div
                      v-if="isAdditionalUser && isAdditionalUserAddon(addon)"
                      class="additional-user-quantity"
                  >
                    <span class="additional-user-current">
                      Current additional users: <strong>{{ getCurrentAddonQuantity(addon) }}</strong>
                    </span>

                    <span
                        v-if="addonProducts[addon.id] && additionalUserSelectedFromCard"
                        class="additional-user-separator"
                    >
                      |
                    </span>

                    <span
                        v-if="addonProducts[addon.id] && additionalUserSelectedFromCard"
                        class="additional-user-adding"
                    >
                      Buying now: <strong>1</strong>
                    </span>
                  </div>


                </div>


                </div>
            </template>
            <div class="cell form-wrapper" v-if="user">
              <div class="row">
                <div class="col-md-12">
                  <h3>Step 1: Your Details:</h3>
                  Signed in as: {{ user.first_name }} ({{ user.email }})
                </div>
                <div class="col-md-12">
                  <template v-if="selectedProduct">
                    <template v-if="hasAnyFalsePlanOrAddon(selectedProduct)">
                    <payment-form
                      :product="selectedProduct"
                      :addonProducts="Object.values(addonProducts)"
                      :user="user"
                      :mode="'upgrade'"
                      ref="payment_form"
                    ></payment-form>
                    </template>
                    <template v-else>
                      <br>
                      <h5>You have already connected all the available features in this plan</h5>
                    </template>
                  </template>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="panel panel-default">
          <div class="panel-heading"><strong>Pricing</strong></div>
          <div class="panel-body">
            <h2 class="text-center">Model Office – MO® Pricing</h2>
            <h4 class="text-center">Success by design</h4>
            <p class="text-justify">MO® helps you identify the Governance, Risk and Compliance (GRC) growth areas and blind spots within your business and ensure you remain compliant, profitable, and client-centric by:</p>
            <p class="text-justify">1. Automatically benchmarking your firm against the latest regulatory rules, The FCA papers across all key issues such as: <b>MiFID II</b>, <b>KYC</b>, <b>AML</b>, <b>Consumer Duty</b>, <b>ESG</b>, <b>GDPR</b>, <b>SM&CR</b>, <b>Competence</b>, <b>Advice Suitability</b>, <b>Cyber</b>, <b>Operational</b>, <b>Financial Resilience</b> and manage new risks e.g., <b>a Pandemic</b></p>
            <p class="text-justify">2. Providing auto-gap analysis and audit reports, tracking your professional progress against good Practice and GRC strategy and integrate with back-office tech to streamline regulatory reports and data analytics to provide trend, theme, strengths, and weaknesses analysis</p>
            <p class="text-justify">3. Ensuring you are up to date with all the latest compliance, financial, business and people resilience and development strategies you need to reduce audit and compliance costs and time and work with PII underwriters to provide quality MI and data analytics dashboards to enable discounted renewal rates.</p>
            <p class="text-justify">Don’t just take our word for it. Request a demo to experience MO® for yourself and your firm or sign up today.</p>

            <table class="table table-bordered table-striped">
              <thead>
              <tr>
                <td></td>
                <td><b>Model Office – MO lite</b></td>
                <td><b>Model Office-MO® Classic</b></td>
                <td><b>MO® Classic Pro</b></td>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td></td>
                <td><b>£70 (+VAT)</b></td>
                <td><b>£190 (+VAT) per month</b></td>
                <td><b>£625 (+VAT) per month</b></td>
              </tr>
              <tr>
                <td><p>Action Tracker and Compliance Diary</p></td>
                <td></td>
                <td>£90 per month</td>
                <td><i class="fa fa-check-square"></i></td>
              </tr>
              <tr>
                <td><p>Digital Compliance Chat bot</p></td>
                <td></td>
                <td>£300 per month</td>
                <td><i class="fa fa-check-square"></i></td>
              </tr>
              <tr>
                <td><p>Back-office integration</p></td>
                <td></td>
                <td>£37 per month</td>
                <td><i class="fa fa-check-square"></i></td>
              </tr>
              <tr>
                <td><p>Financial Resilience Test</p></td>
                <td><i class="fa fa-check"></i></td>
                <td><i class="fa fa-check"></i></td>
                <td><i class="fa fa-check"></i></td>
              </tr>
              <tr>
                <td><p>MO® Users</p></td>
                <td></td>
                <td>Up to 2 Free then £27pm per user</td>
                <td>Up to 2 Free then £39pm per user</td>
              </tr>
              <tr>
                <td><p>Benchmarking</p></td>
                <td><i class="fa fa-check-square"></i></td>
                <td><i class="fa fa-check"></i></td>
                <td><i class="fa fa-check"></i></td>
              </tr>
              <tr>
                <td><p>Comprehensive Regulatory Dashboard</p></td>
                <td></td>
                <td><i class="fa fa-check"></i></td>
                <td><i class="fa fa-check"></i></td>
              </tr>
              <tr>
                <td><p>Bespoke dynamic steers to improve scores</p></td>
                <td><i class="fa fa-check-square"></i></td>
                <td><i class="fa fa-check"></i></td>
                <td><i class="fa fa-check"></i></td>
              </tr>
              <tr>
                <td><p>Structured CPD accreditation and certification</p></td>
                <td></td>
                <td><i class="fa fa-check"></i></td>
                <td><i class="fa fa-check"></i></td>
              </tr>
              <tr>
                <td><p>Compliance data analytics dashboards</p></td>
                <td></td>
                <td></td>
                <td><i class="fa fa-check"></i></td>
              </tr>
              <tr>
                <td><p>Heat Mapped Results dashboard</p></td>
                <td><i class="fa fa-check-square"></i></td>
                <td><i class="fa fa-check"></i></td>
                <td><i class="fa fa-check"></i></td>
              </tr>
              <tr>
                <td><p>Integration 3rd party software*</p></td>
                <td></td>
                <td></td>
                <td><i class="fa fa-check"></i></td>
              </tr>
              <tr>
                <td><p>In-depth best practice market research and benchmarking across the 6 keys’ business functions</p></td>
                <td></td>
                <td><i class="fa fa-check"></i></td>
                <td><i class="fa fa-check"></i></td>
              </tr>
              <tr>
                <td><p>Benchmark performance against peers and good practice</p></td>
                <td></td>
                <td><i class="fa fa-check"></i></td>
                <td><i class="fa fa-check"></i></td>
              </tr>
              <tr>
                <td><p><strong>Framework guidance:</strong><br />Corporate Governance</p></td>
                <td></td>
                <td><i class="fa fa-check"></i></td>
                <td><i class="fa fa-check"></i></td>
              </tr>
              <tr>
                <td><p>Management Information</p></td>
                <td></td>
                <td><i class="fa fa-check"></i></td>
                <td><i class="fa fa-check"></i></td>
              </tr>
              <tr>
                <td><p>MO®nitor Compliance document auto-audit & client file review</p></td>
                <td></td>
                <td>£160 per month</td>
                <td>£160 per month</td>
              </tr>
              <tr>
                <td><p><strong>Your Focus:</strong><br />Compliance strategy/AML, Suitability, KYC, ESG, IDD, MiFIDII</p></td>
                <td><i class="fa fa-check-square"></i></td>
                <td><i class="fa fa-check"></i></td>
                <td><i class="fa fa-check"></i></td>
              </tr>
              <tr>
                <td><p><strong>Your Engagement:</strong><br />Consumer Duty, Marketing, Stakeholders, Segmentation, PROD</p></td>
                <td><i class="fa fa-check-square"></i></td>
                <td><i class="fa fa-check"></i></td>
                <td><i class="fa fa-check"></i></td>
              </tr>
              <tr>
                <td><p><strong>Consumer Duty:</strong><br />Governance, Cross cutting rules, 4 Outcomes, Data & MI, Vulnerability</p></td>
                <td><i class="fa fa-check-square"></i></td>
                <td><i class="fa fa-check"></i></td>
                <td><i class="fa fa-check"></i></td>
              </tr>
              <tr>
                <td><p><strong>Your Promise:</strong><br />Centralised investment/retirement/service proposition</p></td>
                <td><i class="fa fa-check-square"></i></td>
                <td><i class="fa fa-check"></i></td>
                <td><i class="fa fa-check"></i></td>
              </tr>
              <tr>
                <td><p><strong>Your Systems:</strong><br />Business, Client Admin management, tasks, workflows, data, Cyber-risks</p></td>
                <td><i class="fa fa-check-square"></i></td>
                <td><i class="fa fa-check"></i></td>
                <td><i class="fa fa-check"></i></td>
              </tr>
              <tr>
                <td><p><strong>Your People:</strong><br />Human Resource Development, recruitment, training, competence, conduct SM&CR</p></td>
                <td><i class="fa fa-check-square"></i></td>
                <td><i class="fa fa-check"></i></td>
                <td><i class="fa fa-check"></i></td>
              </tr>
              <tr>
                <td><p>Marketing strategy</p></td>
                <td></td>
                <td><i class="fa fa-check"></i></td>
                <td><i class="fa fa-check"></i></td>
              </tr>
              <tr>
                <td><p>Client documentation</p></td>
                <td></td>
                <td><i class="fa fa-check"></i></td>
                <td><i class="fa fa-check"></i></td>
              </tr>
              <tr>
                <td><p>Centralised Investment Proposition</p></td>
                <td></td>
                <td><i class="fa fa-check"></i></td>
                <td><i class="fa fa-check"></i></td>
              </tr>
              <tr>
                <td><p>Client digital engagement strategies</p></td>
                <td></td>
                <td><i class="fa fa-check"></i></td>
                <td><i class="fa fa-check"></i></td>
              </tr>
              <tr>
                <td><p>Cyber-risk strategies</p></td>
                <td></td>
                <td><i class="fa fa-check"></i></td>
                <td><i class="fa fa-check"></i></td>
              </tr>
              <tr>
                <td><p>Mature practice management strategies</p></td>
                <td></td>
                <td><i class="fa fa-check"></i></td>
                <td><i class="fa fa-check"></i></td>
              </tr>
              <tr>
                <td><p>Employee engagement</p></td>
                <td></td>
                <td><i class="fa fa-check"></i></td>
                <td><i class="fa fa-check"></i></td>
              </tr>
              <tr>
                <td><p>Pop up resource statements for technical questions</p></td>
                <td></td>
                <td><i class="fa fa-check"></i></td>
                <td><i class="fa fa-check"></i></td>
              </tr>
              <tr>
                <td><p>Limited steers to improve scores</p></td>
                <td><i class="fa fa-check"></i></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td><p>Training and support</p></td>
                <td></td>
                <td><i class="fa fa-check"></i></td>
                <td><i class="fa fa-check"></i></td>
              </tr>
              </tbody>
            </table>

            <p>*Available for certain practice management technology users and costs for MO® standard depend on integration strategy</p>
            <p><i class="fa fa-check-square"></i> Limited resources available</p>
            <p>For Institutional and white-labeled prices please contact info@model-office.co.uk</p>

          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div v-if="selectedProduct" class="panel panel-default sidebar">
          <div class="panel-heading"><strong>Subscription Summary</strong></div>
          <div class="panel-body">
            <div class="subscription-summary">
              <div class="summary-item">
                <div class="summary-item-title"><strong>{{ selectedProduct.name }}</strong></div>
                <div class="summary-item-price"><strong>{{ prices.main }}</strong></div>
              </div>
              <div class="summary-item" v-if="Object.values(addonProducts).length > 0">
                <div class="summary-item-title">Addons</div>
                <div class="summary-item-price">{{ prices.addons }}</div>
              </div>
              <div class="summary-delimiter"></div>
              <div class="summary-item">
                <div class="summary-item-title">Subtotal</div>
                <div class="summary-item-price">{{ prices.subtotal }}</div>
              </div>
              <div class="summary-item">
                <div class="summary-item-title">{{title_vat}}</div>
                <div class="summary-item-price">{{ prices.vat }}</div>
              </div>
              <div class="summary-delimiter"></div>
              <div class="summary-item">
                <div class="summary-item-title"><strong>Total subscription</strong></div>
                <div class="summary-item-price"><strong>{{ prices.total }}</strong></div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel panel-default sidebar">
          <div class="panel-heading"><strong>By purchasing your MO license today you will gain the
            following:</strong></div>
          <div class="panel-body">
            <ul>
              <li>
                <strong>
                  Your Focus: Compliance, risk and Management Information (MI).
                </strong>
                <ul>
                  <li>
                    The ability to scan your business development across key strategies:
                    Compliance, Corporate governance, Risk management and Cyber-risks.
                  </li>
                </ul>
              </li>
              <li>
                <strong>
                  Your Engagement: Client and stakeholder relationships.
                </strong>
                <ul>
                  <li>
                    Understand the strength and depth of your client communications and
                    marketing strategies.
                  </li>
                </ul>
              </li>
              <li>
                <strong>
                  Consumer Duty Validation:
                </strong>
                <ul>
                  <li>
                    Ensure your Consumer Duty implementation remains compliant with all FCA requirements
                  </li>
                </ul>
              </li>
              <li>
                <strong>
                  Your Promise: Centralised investment and service proposition.
                </strong>
                <ul>
                  <li>
                    Ensure a robust research and due diligence process across the proposition.
                  </li>
                </ul>
              </li>
              <li>
                <strong>
                  Your Systems: Operations and service supports.
                </strong>
                <ul>
                  <li>
                    Client relationship management systems focus on opportunity management.
                  </li>
                </ul>
              </li>
              <li>
                <strong>
                  Your people: Employee engagement and talent development.
                </strong>
                <ul>
                  <li>
                    Ensure your business has the right people in the right role with the right
                    skills and you identify and retain the right talent.
                  </li>
                </ul>
              </li>
              <li>
                <strong>
                  Your Performance Dashboard
                </strong>
                <ul>
                  <li>
                    All the above will be benchmarked against our research into wealth manager
                    and adviser firm professional practice.
                  </li>
                </ul>
              </li>
            </ul>

          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import PaymentForm from './PaymentForm'

export default {
  name: "Upgrade",
  components: {
    'payment-form': PaymentForm,
  },
  data() {
    return {
      user: null,
      additionalProductAddons: [],
      ioSingleAdditionalProductAddons: [],
      ioBulkAdditionalProductAddons: [],
      additionalUserAdditionalProductAddons: [],
      products: null,
      selectedProduct: null,
      addonProducts: {},
      additionalUserSelectedFromCard: false,
      title_vat: 'Vat',
      prices: {
        main: 0,
        addons: 0,
        subtotal: 0,
        vat: 0,
        total: 0,
      },
    }
  },
  props: ["tax_rate"],
  computed: {
    isScanOnly() {
      return this.$route.query.scan_only === 'true';
    },
    isIOSingleReview() {
      return this.$route.query.io_single_review === 'true';
    },
    isIOBulkReview() {
      return this.$route.query.io_bulk_review === 'true';
    },
    isAdditionalUser() {
      return this.$route.query.additional_user === 'true';
    },
    additionalAddonPath() {

      if (this.$route.query.io_single_review === 'true') {
        return '/additional-product-addons/io_single_reviews'
      }

      if (this.$route.query.io_bulk_review === 'true') {
        return '/additional-product-addons/io_bulk_reviews'
      }

      if (this.$route.query.scan_only === 'true') {
        return '/additional-product-addons'
      }

      if (this.$route.query.additional_user === 'true') {
        return '/additional-product-addons/additional_user'
      }

      return null
    }
  },
  methods: {
    upgrade() {
      this.$refs.payment_form.upgrade()
    },
    getUser() {
      axios.get('/user').then((res) => {
        this.user = res.data
      }).catch((error) => {
        console.log('error', error)
      })
    },
    getProducts() {
      axios
        .get("/products/upgrade")
        .then((res) => {
          this.products = this.addFormattedPrice(res.data.data);
          //this.selectProduct(this.products[0]);
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    selectProduct($product) {
      this.selectedProduct = $product;
      this.addonProducts = {};
      this.additionalUserSelectedFromCard = false;
      this.updatePrice();
    },
    selectAdditionalUserAddon(product) {
      let currentPlan = this.selectedProduct;

      if (!currentPlan) {
        currentPlan = Object.values(this.products || {}).find((item) => item.is_current_plan);
      }

      if (!currentPlan) {
        console.log('Current plan not found');
        return;
      }

      this.selectedProduct = currentPlan;
      this.additionalUserSelectedFromCard = true;

      if (!this.selectedProduct.addons) {
        this.selectedProduct.addons = [];
      }

      const existingAddon = this.selectedProduct.addons.find((addon) => addon.id === product.id);

      if (existingAddon) {
        existingAddon.is_current_addon = true;
      } else {
        this.selectedProduct.addons.push({
          ...product,
          is_current_addon: true
        });
      }

      const currentQuantity = this.getCurrentAddonQuantity(product);

      this.addonProducts = {
        ...this.addonProducts,
        [product.id]: {
          quantity: currentQuantity + 1,
          current_qty: currentQuantity,
          id: product.id,
          price: product.price
        }
      };

      this.updatePrice();
    },
    getAddonProductForDisplay(addon) {
      if (!this.isAdditionalUser || !this.isAdditionalUserAddon(addon)) {
        return addon;
      }

      return {
        ...addon,
        is_current_addon: !!this.addonProducts[addon.id] && this.additionalUserSelectedFromCard,
      };
    },
    isAdditionalUserAddon(product) {
      return [
        'additional_user_classic',
        'additional_user_classic_pro',
        'additional_user',
      ].includes(product.slug);
    },
    getCurrentAddonQuantity(product) {
      return product.current_qty || 0;
    },
    toggleAddon(selected, product) {
      if (selected) {
        const isAdditionalUserPurchase = this.isAdditionalUser && this.isAdditionalUserAddon(product);

        const currentQuantity = isAdditionalUserPurchase
            ? this.getCurrentAddonQuantity(product)
            : 0;

        const quantity = isAdditionalUserPurchase
            ? currentQuantity + 1
            : (this.addonProducts[product.id]?.quantity || 1);

        this.addonProducts = {
          ...this.addonProducts,
          [product.id]: {
            quantity: quantity,
            current_qty: currentQuantity,
            id: product.id,
            price: product.price
          }
        };
      } else {
        const addonProducts = { ...this.addonProducts };
        delete addonProducts[product.id];
        this.addonProducts = addonProducts;
      }

      this.updatePrice();
    },
    updatePrice() {
      let main = +this.selectedProduct.price;
      let addons = 0;

      Object.values(this.addonProducts).forEach((item) => {
        const currentQty = item.current_qty || 0;
        const addedQty = Math.max(item.quantity - currentQty, 0);

        addons += item.price * addedQty;
      });

      let subtotal = +main + addons;
      let vat = subtotal * this.tax_rate * 0.01;
      let total = subtotal + vat;

      let currency = this.selectedProduct.currency !== '' ? this.selectedProduct.currency : 'gbp';

      let locale = 'en-GB';

      if (currency === 'aud') {
        this.title_vat = 'GST'
      }

      var formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
      });

      this.prices = {
        main: formatter.format(main),
        addons: formatter.format(addons),
        subtotal: formatter.format(subtotal),
        vat: formatter.format(vat),
        total: formatter.format(total),
      };
    },
    addFormattedPrice(products) {
      Object.values(products).forEach((item) => {
        item.price_formatted = 0;
        const currency = item.currency;
        if (currency) {
          const formatter = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: currency,
          });
          item.price_formatted = formatter.format(item.price);
        }
      });

      return products;
    },
    getAdditionalProductAddons() {

      if (!this.additionalAddonPath) return;

      axios.get(this.additionalAddonPath)
          .then(res => {

            if (!res.data.data) return;

            if (this.isScanOnly) {
              this.additionalProductAddons = this.addFormattedPrice(res.data.data);
            }

            if (this.isIOSingleReview) {
              this.ioSingleAdditionalProductAddons = this.addFormattedPrice(res.data.data);
            }

            if (this.isIOBulkReview) {
              this.ioBulkAdditionalProductAddons = this.addFormattedPrice(res.data.data);
            }

            if (this.isAdditionalUser) {
              this.additionalUserAdditionalProductAddons = this.addFormattedPrice(res.data.data);
            }

          })
    },
    hasAnyFalsePlanOrAddon(product) {
      if (!product.is_current_plan) {
        return true;
      }

      if (this.isAdditionalUser) {
        return this.additionalUserSelectedFromCard && Object.values(this.addonProducts).length > 0;
      }

      return Object.values(this.addonProducts).some((selectedAddon) => {
        const addon = product.addons.find((item) => item.id === selectedAddon.id);

        return addon && !addon.is_current_addon;
      });
    },
  },
  created() {
    this.getUser()
    this.getProducts()
    this.$router.isReady().then(() => {
      this.getAdditionalProductAddons()
    })
  }
}
</script>


<style scoped>
  .disabled {
    pointer-events: none;
    opacity: 0.5;
  }
  .container.auth-page .subscription-plans-container .current-plan,
  .container.auth-page .subscription-plans-container .current-plan.active {
    background-color: #73C2AF;
    border-color: #73C2AF;
  }
  .current-plan-text {
      margin: 10px 0 0 0;
  }
  .additional-user-quantity {
    margin: 4px 0 10px 32px;
  }

  .additional-user-current {
    margin-bottom: 4px;
    font-size: 13px;
    font-weight: bold;
  }

  .additional-user-quantity {
    margin: 4px 0 10px 32px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
  }

  .additional-user-current,
  .additional-user-adding {
    white-space: nowrap;
  }

  .additional-user-separator {
    color: #999;
  }
</style>